import React, { useEffect, useState } from 'react'
import AnDateField from '../../components/DateTime/DateField'
import API from '../../services/API'
import S3DocumentUploadDisplay from '../../components/images/S3DocumentUploadDisplay'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import { FormSection, YesNoQuestion } from './FormKit'

const Qualifications = ({ formValues, setFormValues }) => {
  const [roleOptions, setRoleOptions] = useState([])
  useEffect(() => {
    API.get('/settings?select=roles%20restrictApplicationsByRole').then(
      (res) => {
        if (res.data?.restrictApplicationsByRole?.length > 0) {
          setRoleOptions(res.data.restrictApplicationsByRole)
        } else {
          setRoleOptions(res.data.roles ?? [])
        }
      },
    )
  }, [])

  const isHCP = formValues?.qualifications?.isHCP
  const registration = formValues?.employee?.registrationNumber

  const setRegistration = (patch) =>
    setFormValues((prev) => ({
      ...prev,
      employee: {
        ...prev.employee,
        registrationNumber: { ...prev.employee?.registrationNumber, ...patch },
      },
    }))

  const saveDocuments = (documents) => {
    setFormValues((prev) => ({
      ...prev,
      qualifications: { ...prev.qualifications, documents },
    }))
    API.post('/update-employee-own-application', {
      _id: formValues._id,
      qualifications: { ...formValues.qualifications, documents },
    })
  }

  return (
    <Stack gap={2}>
      <FormSection title="The role">
        <FormControl required fullWidth sx={{ maxWidth: { sm: 400 } }}>
          <InputLabel>Role you are applying for</InputLabel>
          <Select
            value={formValues?.employee?.clinicalRole ?? ''}
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: { ...prev.employee, clinicalRole: e.target.value },
              }))
            }
            label="Role you are applying for"
          >
            {roleOptions.map((x) => (
              <MenuItem key={x} value={x}>
                {x}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FormSection>

      <FormSection title="Professional registration">
        <YesNoQuestion
          label="Are you a Paramedic, Nurse or Doctor?"
          value={isHCP}
          onChange={(value) =>
            setFormValues((prev) => ({
              ...prev,
              qualifications: { ...prev.qualifications, isHCP: value },
            }))
          }
        />
        {isHCP === true && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth required>
                <InputLabel>Registration body</InputLabel>
                <Select
                  value={registration?.body ?? ''}
                  onChange={(e) => setRegistration({ body: e.target.value })}
                  label="Registration body"
                >
                  <MenuItem value="HCPC">HCPC</MenuItem>
                  <MenuItem value="NMC">NMC</MenuItem>
                  <MenuItem value="GMC">GMC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                value={registration?.number ?? ''}
                onChange={(e) => setRegistration({ number: e.target.value })}
                required
                fullWidth
                label="Registration number"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <AnDateField
                date={registration?.renewDate ?? null}
                onChange={(newDate) => setRegistration({ renewDate: newDate })}
                label="Renewal date"
                required
                fullWidth
                disablePast
              />
            </Grid>
          </Grid>
        )}
      </FormSection>

      <FormSection
        title="Certificates"
        caption="Upload certificates for any relevant qualifications — clinical, first aid, driving or otherwise."
      >
        <S3DocumentUploadDisplay
          existingDocuments={formValues?.qualifications?.documents}
          s3folder="employees/application-qualifications-documents"
          actionAfterSubmit={(newDocKey) =>
            saveDocuments([
              ...(formValues?.qualifications?.documents ?? []),
              newDocKey,
            ])
          }
          actionAfterDelete={(newDocsArray) => saveDocuments(newDocsArray)}
        />
      </FormSection>
    </Stack>
  )
}

export default Qualifications
